import React, { useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import UserAvatar from '../../../header/components/user-profile/UserAvatar';
import CommonButton from '../../../components/common-button/CommonButton';
import { logout } from '../../../service/callApi';
import useFormattedName from '../../../hooks/useFormattedName';
import ChangeUserPasswordModal from '../../../user-management/change-password-modal/ChangeUserPasswordModal';

import scss from './UserMenu.module.scss';

function UserMenu() {
  const { t } = useTranslation('header');
  const currentUserInfo = useSelector((state) => state.securityNew.currentUserInfo);

  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);

  const formattedName = useFormattedName();

  const handleOpenChangePasswordModal = () => {
    setIsChangePasswordModalOpen(true);
  };

  const handleCloseChangePasswordModal = () => {
    setIsChangePasswordModalOpen(false);
  };

  return (
    <div className={scss.wrapper}>
      <div className={scss.profileBLock}>
        <UserAvatar name={formattedName} />
        <div className={scss.userName}>{formattedName}</div>
      </div>

      <ul className={scss.actionList}>
        <li className={clsx(scss.actionRow, scss.actionRowDisabled)} role='presentation'>
          {t('settings')}
        </li>
        <li className={scss.actionRow} onClick={handleOpenChangePasswordModal} role='presentation'>
          {t('changePassword')}
        </li>
        <li className={scss.actionRow}>
          <CommonButton styleColor='secondary' onClick={logout} maxWidth={200}>
            {t('logout')}
          </CommonButton>
        </li>
      </ul>

      <ChangeUserPasswordModal
        isOpen={isChangePasswordModalOpen}
        username={currentUserInfo.username}
        onClose={handleCloseChangePasswordModal}
      />
    </div>
  );
}

export default UserMenu;
